'use strict';

angular.module('shiftTraderApp')
  .directive('saProfilePhotoUpload', function () {
    return {
      templateUrl: 'views/directives/saProfilePhotoUpload.html',
      replace: false,
      restrict: 'A',
      scope: {
        source: '=',
        profileType: '@'
      },
      controller: ['$scope', '$q', 'ServerUrls', 'Session', 'UserPermissionsService',  function ($scope, $q, ServerUrls, Session, UserPermissionsService) {
        var me = null;

        $scope.state = {
          progress: 0,
          setupComplete: false,
          rawPermissions: null,
          derivedPermissions: null,
          avatar: {
            url: null
          }
        };

        var permissionsToLookUp = [];
        var action = null;
        if ($scope.profileType === 'user') {
          $scope.source._image_updated_at = $scope.source.avatar_updated_at;
          $scope.state.uploaderInputName = 'user[avatar]';
          $scope.state.avatar.url = $scope.source.avatar_urls.profile;
          permissionsToLookUp = [
            'users.change_my_avatar',
            'users.change_avatar'
          ];
          action = ServerUrls.current.railsApi + 'users/' + $scope.source.id;
        } else if ($scope.profileType === 'organization') {
          $scope.source._image_updated_at = $scope.source.logo_updated_at;
          $scope.state.avatar.url = $scope.source.logo_urls.profile;
          $scope.state.uploaderInputName = 'organization[logo]';
          permissionsToLookUp = [
            'organizations.update'
          ];
          action = ServerUrls.current.railsApi + 'organizations/' + $scope.source.id;
        }

        var setup = function() {
          var setupPromises = [
            Session.getMe(),
            UserPermissionsService.getCanDict(permissionsToLookUp, 'current')
          ];

          $q.all(setupPromises)
            .then(function(results) {
              me = results[0];
              $scope.state.rawPermissions = results[1];

              processRawPermissions();

              $scope.state.setupComplete = true;
            });
        };

        function processRawPermissions() {
          var rawPerm = $scope.state.rawPermissions;

          var hasPermissionToChange = false;
          if ($scope.profileType === 'user') {
            hasPermissionToChange = (me.id === $scope.source.id && rawPerm['users.change_my_avatar']) || rawPerm['users.change_avatar'];
          } else if ($scope.profileType === 'organization') {
            hasPermissionToChange = rawPerm['organizations.update'];
          }

          $scope.state.derivedPermissions = {
            canChangeAvatar: hasPermissionToChange
          };
        }

        setup();

        $scope.removeProfileImage = function() {
          var payload = null;

          if ($scope.profileType === 'user') {
            payload = { user: { delete_avatar: 1 } };
          } else if ($scope.profileType === 'organization') {
            payload = { organization: { delete_logo: 1 } };
          }

          $scope.source.$update(payload)
            .then(function(response) {
              if ($scope.profileType === 'user') {
                $scope.source.avatar_urls = response.avatar_urls;
                $scope.source.avatar_updated_at = response.avatar_updated_at;
                $scope.state.avatar.url = response.avatar_urls.profile;
              } else if ($scope.profileType === 'organization') {
                $scope.source.logo_urls = response.logo_urls;
                $scope.source.logo_updated_at = response.logo_updated_at;
                $scope.state.avatar.url = response.logo_urls.profile;
              }
              $scope.source._image_updated_at = null;
            });
        };

        $scope.sendFile = function(el) {
          var $form = $(el).parents('form');
          if ($(el).val() == '') {
            return false;
          }

          $form.attr('action', action)
          $('<input />').attr('type', 'hidden')
                        .attr('name', 'access_token')
                        .attr('value', Session.getAccessToken())
                        .appendTo($form);

          $scope.$apply(function() {
            $scope.state.progress = 0;
          });

          $form.ajaxSubmit({
            type: 'PUT',
            uploadProgress: function(event, position, total, percentComplete) {
              // Update the progress while it is uploading
              $scope.$apply(function() {
                $scope.state.progress = percentComplete;
              });
            },
            error: function(event, statusText, response, form) {
              // Remove the action attribute from the form
              $form.removeAttr('action');
              $scope.state.progress = 0;
              console.log('Encountered an error while submitting photo', response);
            },
            success: function(response, statusText, xhr, form) {
              // Remove the action attribute from the form
              console.log('Success', response);
              $form.removeAttr('action');

              $scope.$apply(function() {
                if ($scope.profileType === 'user') {
                  $scope.source.avatar_urls = response.avatar_urls;
                  $scope.source.avatar_updated_at = response.avatar_updated_at;
                  $scope.state.avatar.url = response.avatar_urls.profile;
                  $scope.source._image_updated_at = $scope.source.avatar_updated_at;
                } else if ($scope.profileType === 'organization') {
                  $scope.source.logo_urls = response.logo_urls;
                  $scope.source.logo_updated_at = response.logo_updated_at;
                  $scope.state.avatar.url = response.logo_urls.profile;
                  $scope.source._image_updated_at = $scope.source.logo_updated_at;
                }
                $scope.state.progress = 0;
              });
            }
          });
        };
      }],
      link: function(scope, elem) {
        elem.find('.fake-uploader').click(function() {
          elem.find('input[type="file"]').click();
        });
      }
    };
  });
